export const selector = 'dbAScrollIntoView';

/* @ngInject */
export default function ScrollIntoViewDirective($parse, $timeout) {
    return {
        restrict: 'A',
        require: '^dbAScrollContainer',
        
        link(scope, element, attrs, container) {
            const getter = $parse(attrs[selector]);
            const shouldScroll = getter(scope);

            if (shouldScroll) {
                $timeout(() => container.scrollToElement(element[0]));
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/scroll-into-view/scroll-into-view.directive.js